<template>
  <div class="tes-card pa-7">
    <h1 class="tes-card__title">{{$t('pages.meteringDevices.characteristics')}}</h1>

    <v-flex class="mt-3" sm="6" cols="12">
      <account-select @loading="toggleLoading" :onlyIsOwner="false">
        <span class="select-prepend subtitle-1 pt-0">{{$t('personalAccount')}}:</span>
      </account-select>
    </v-flex>
    <v-flex xs12>
      <loader-wrapper
        :loading="loading"
        :opacity="0.8"
        :showNoDataText="!currentDevices.length"
      >
        <table-wrapper
          v-if="windowSize.x > 768"
          :headers="headers"
          :items="currentDevices"
          :disable-pagination="true"
          hide-default-footer
          class="data-table"
          ref="table"
          :items-per-page.sync="currentDevices.length || 20"
        >
          <template v-slot:header.text.meterNumber>
            {{$t('pages.meteringDevices.meteringDevice').split(' ')[0]}}
            <br />{{$t('pages.meteringDevices.meteringDevice').split(' ')[1]}}
          </template>
          <template v-slot:header.text.meterClass>
            {{$t('pages.meteringDevices.bitDepth').split('/')[0]}}/
            <br /> {{$t('pages.meteringDevices.bitDepth').split('/')[1]}}
          </template>
          <template v-slot:header.text.checkNextDate>
            {{$t('pages.meteringDevices.nextVerification').split(' ')[0]}}
            <br />{{$t('pages.meteringDevices.nextVerification').split(' ')[1]}}
          </template>
          <template v-slot:header.text.place>
            {{$t('pages.meteringDevices.place').split(' ')[0]}}
            <br /> {{$t('pages.meteringDevices.place').split(' ')[1]}}
          </template>
          <template v-slot:header.text.responsible>
            Ответственный
            <br />за эксплуатацию
          </template>
          <template v-slot:header.text.installDate>
            {{$t('pages.meteringDevices.dateConnect').split(' ')[0]}}
            <br />{{$t('pages.meteringDevices.dateConnect').split(' ')[1]}}<br />{{$t('pages.meteringDevices.dateConnect').split(' ')[2]}}
          </template>
          <template v-slot:header.text.pu_id> {{$t('pages.meteringDevices.additionally')}} </template>

          <template v-slot:item.checkDate="{ item }">{{
            humanDate(item.checkDate)
          }}</template>
          <template v-slot:item.checkNextDate="{ item }">{{
            humanDate(item.checkNextDate)
          }}</template>
          <template v-slot:item.place="{ item }">
            <div class="current-place-container">
              <div class="current-place-placeholder">
                <div>{{ item.place }}
                <v-icon class="pencil mr-2" :disabled="!item.isExist" >mdi-pencil </v-icon>
                </div>
              </div>
              <div class="current-place-value">
                <v-edit-dialog>
                  <template v-slot:input>
                    <v-text-field v-if="item.isExist"
                      :value="item.place"
                      type="text"
                      color="#ff721c"
                      single-line
                      @change="savePlace($event, item)"
                      :maxlength="maxLength"
                    />
                  </template>
                </v-edit-dialog>
              </div>
            </div>
          </template>
          <template v-slot:item.installDate="{ item }">{{
            humanDate(item.installDate)
          }}</template>
          <template v-slot:item.lk_iku="{ item }">
            <div></div>
            <div
              v-if="item.lk_iku && item.serviceName && !item.serviceName.toLowerCase().includes('электро')"
              class="table-additionally"
            >
              <button @click="toTatNeft(item.meterNumber)" class="table-link">
                {{$t('pages.meteringDevices.details').split(',')[0]}}
                <br />
                {{$t('pages.meteringDevices.details').split(',')[1]}}
              </button>
              <v-tooltip bottom max-width="170">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="red--text table-icon" v-bind="attrs" v-on="on">
                    mdi-alert-circle
                  </v-icon>
                </template>
                <span class="table-tooltip"
                  >{{$t('pages.meteringDevices.transition')}}</span
                >
              </v-tooltip>
            </div>
            <div v-if="item.pu_id" class="table-additionally">
              <button @click="toISUE(item.pu_id)" class="table-link">
                {{$t('pages.meteringDevices.details').split(',')[0]}}
                <br />
                {{$t('pages.meteringDevices.details').split(',')[1]}}
              </button>
              <v-tooltip bottom max-width="170">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="red--text table-icon" v-bind="attrs" v-on="on">
                    mdi-alert-circle
                  </v-icon>
                </template>
                <span class="table-tooltip"
                  >{{$t('pages.meteringDevices.transitionElectricity')}}</span
                >
              </v-tooltip>
            </div>
          </template>
        </table-wrapper>

        <v-data-table
          v-else
          :headers="headers"
          :items="currentDevices"
          :disable-pagination="true"
          hide-default-footer
          ref="table"
          :items-per-page.sync="currentDevices.length || 20"
          class="tes-table-wrapper"
        >
          <template v-slot:header.text.meterNumber>
            {{$t('pages.meteringDevices.meteringDevice').split(' ')[0]}}
            <br />{{$t('pages.meteringDevices.meteringDevice').split(' ')[1]}}
          </template>
          <template v-slot:header.text.meterClass>
            {{$t('pages.meteringDevices.bitDepth').split('/')[0]}}/
            <br /> {{$t('pages.meteringDevices.bitDepth').split('/')[1]}}
          </template>
          <template v-slot:header.text.checkNextDate>
            {{$t('pages.meteringDevices.nextVerification').split(' ')[0]}}
            <br />{{$t('pages.meteringDevices.nextVerification').split(' ')[1]}}
          </template>
          <template v-slot:header.text.place>
             {{$t('pages.meteringDevices.place').split(' ')[0]}}
            <br /> {{$t('pages.meteringDevices.place').split(' ')[1]}}
          </template>
          <template v-slot:header.text.responsible>
            Ответственный
            <br />за эксплуатацию
          </template>
          <template v-slot:header.text.installDate>
            {{$t('pages.meteringDevices.dateConnect').split(' ')[0]}}
            <br />{{$t('pages.meteringDevices.dateConnect').split(' ')[1]}} <br />{{$t('pages.meteringDevices.dateConnect').split(' ')[2]}}
          </template>
          <template v-slot:header.text.pu_id> {{$t('pages.meteringDevices.additionally')}} </template>

          <template v-slot:item.checkDate="{ item }">{{
            humanDate(item.checkDate)
          }}</template>
          <template v-slot:item.checkNextDate="{ item }">{{
            humanDate(item.checkNextDate)
          }}</template>
          <template v-slot:item.installDate="{ item }">{{
            humanDate(item.installDate)
          }}</template>
           <template v-slot:item.place="{ item }">
            <div class="current-place-container">
              <div class="current-place-placeholder">
                <div>{{ item.place }}
                <v-icon class="pencil mr-2" :disabled="!item.isExist">mdi-pencil </v-icon>
                </div>
              </div>
              <div class="current-place-value">
                <v-edit-dialog>
                  <template v-slot:input>
                    <v-text-field
                      v-if="item.isExist"
                      :value="item.place"
                      :maxlength="maxLength"
                      type="text"
                      color="#ff721c"
                      single-line
                      @change="savePlace($event, item)"
                    />
                  </template>
                </v-edit-dialog>
              </div>
            </div>
          </template>
          <template v-slot:item.lk_iku="{ item }">
            <div
              v-if="item.lk_iku && item.serviceName && !item.serviceName.toLowerCase().includes('электро')"
              class="table-additionally"
            >
              <button @click="toTatNeft(item.meterNumber)" class="table-link">
                {{$t('pages.meteringDevices.details').split(',')[0]}}
                <br />
                {{$t('pages.meteringDevices.details').split(',')[1]}}
              </button>
              <v-tooltip bottom max-width="170">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="red--text table-icon" v-bind="attrs" v-on="on">
                    mdi-alert-circle
                  </v-icon>
                </template>
                <span class="table-tooltip"
                  >{{$t('pages.meteringDevices.transition')}}</span
                >
              </v-tooltip>
            </div>
            <div v-if="item.pu_id" class="table-additionally">
              <button @click="toISUE(item.pu_id)" class="table-link">
                {{$t('pages.meteringDevices.details').split(',')[0]}}
                <br />
                {{$t('pages.meteringDevices.details').split(',')[1]}}
              </button>
              <v-tooltip bottom max-width="170">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="red--text table-icon" v-bind="attrs" v-on="on">
                    mdi-alert-circle
                  </v-icon>
                </template>
                <span class="table-tooltip"
                  >{{$t('pages.meteringDevices.transitionElectricity')}}</span
                >
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
        <v-row class="mt-4">
          <v-col class="mt-3 mt-sm-0 text-center text-sm-rigth">
            <v-btn
              class="save-btn text-none float-sm-right mt-3 mt-sm-0"
              @click="sendPlaceDevices"
              :loading="loading"
              :disabled="masChangePlace.length <= 0"
              >{{$t('pages.meteringDevices.save')}}</v-btn
            >
          </v-col>
        </v-row>
      </loader-wrapper>
    </v-flex>
  </div>
</template>

<script>
import PersonalAccountSelect from "../../../components/common/PersonalAccountSelect";
import TableWrapper from "../../../components/wrapper/VTableWrapper";
import { mapGetters } from "vuex";
import moment from "moment";

import LoaderWrapper from "@/components/common/LoaderWrapper";

export default {
  name: "index",
  layout: "main",
  components: {
    "account-select": PersonalAccountSelect,
    "table-wrapper": TableWrapper,
    LoaderWrapper,
  },
  computed: {
    ...mapGetters("indication", ["currentDevices"]),
    headers(){
      return [
      {
        text: "Ресурс",
        align: "center",
        value: "serviceName",
        class: "subtitle-1",
        isFixed: true,
        isSortable: false,
        isResizable: true,
        th: {
          style: {
            height: "80px",
          },
        },
      },
      {
        text: this.$t('pages.meteringDevices.meteringDevice'),
        align: "center",
        value: "meterNumber",
        class: "subtitle-1",
        isFixed: true,
        isSortable: false,
        isResizable: true,
        th: {
          style: {
            height: "80px",
          },
        },
      },
      {
        text: "Марка",
        align: "center",
        value: "type",
        class: "subtitle-1",
        isSortable: false,
        isResizable: true,
        th: {
          style: {
            height: "80px",
          },
        },
      },
      {
        text: this.$t('pages.meteringDevices.bitDepth'),
        align: "center",
        value: "meterClass",
        class: "subtitle-1",
        isSortable: false,
        isResizable: true,
        th: {
          style: {
            height: "80px",
          },
        },
      },
      {
        text: this.$t('pages.meteringDevices.verification'),
        align: "center",
        value: "checkDate",
        class: "subtitle-1",
        isSortable: false,
        isResizable: true,
        th: {
          style: {
            height: "80px",
          },
        },
      },
      {
        text:  this.$t('pages.meteringDevices.nextVerification'),
        align: "center",
        value: "checkNextDate",
        class: "subtitle-1",
        isSortable: false,
        isResizable: true,
        th: {
          style: {
            height: "80px",
          },
        },
      },
      {
        text: this.$t('pages.meteringDevices.place'),
        align: "center",
        value: "place",
        class: "subtitle-1",
        isSortable: false,
        isResizable: true,
        th: {
          style: {
            height: "80px",
          },
        },
      },
      {
        text: this.$t('pages.meteringDevices.dateConnect'),
        align: "center",
        value: "installDate",
        class: "subtitle-1",
        isSortable: false,
        isResizable: true,
        th: {
          style: {
            height: "80px",
          },
        },
      },
      {
        text: this.$t('pages.meteringDevices.additionally'), 
        align: "center",
        value: "lk_iku",
        class: "subtitle-1",
        isSortable: false,
        isResizable: true,
        width: "180px",
        th: {
          style: {
            height: "80px",
            width: "200px",
          },
        },
      },
    ]
    }
  },
  data: () => ({
    windowSize: {
      x: 0,
      y: 0,
    },
    loading: false,
    masChangePlace: [],
    maxLength: 11,
  }),
  created() {
    this.$store.dispatch("indication/loadDevices").finally(() => {
      this.loading = false;
    });
  },
  mounted() {
    this.onResize();
  },
  methods: {
    humanDate(date) {
      let human = new Date(date);
      let result = moment(human).format("DD.MM.YYYY");

      return date === 0 ? "-" : result;
    },
    onResize() {
      this.windowSize = {
        x: window.innerWidth,
        y: window.innerHeight,
      };
    },
    toggleLoading(value = false) {
      // console.log('toggleLoading')
      // console.log(value)

      this.loading = value;
    },
    toTatNeft(meterNumber) {
      this.loading = true;
      this.$store
        .dispatch("indication/GetToken", { meterNumber })
        .then((response) => {
          if (response.success) {
            const link = document.createElement("a");
            link.href = `${response.url}`;
            link.target = "_blank";
            link.click();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toISUE(pu_id) {
      this.loading = true;
      this.$store
        .dispatch("indication/returnLogOn", { pu_id })
        .then((response) => {
          if (response.success) {
            const link = document.createElement("a");
            link.href = `${process.env.VUE_APP_ISUE_URL}?access_token=${response.token}`;
            link.target = "_blank";
            link.click();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    savePlace(item, current) {
      current.place = item;
      if (!this.masChangePlace.includes(current.meterNumber)) {
        this.masChangePlace.push(current.meterNumber);
      }
    },
    sendPlaceDevices() {
      if (this.masChangePlace.length > 0) {
        let request = {
          places: [],
        };

        for (let i = 0; i < this.currentDevices.length; i++) {
          if (this.masChangePlace.includes(this.currentDevices[i].meterNumber)) {
            request.places.push({
              idPribors: this.currentDevices[i].idPribors,
              meterNumber: this.currentDevices[i].meterNumber,
              place: this.currentDevices[i].place,
            });
          }
        }
        
      this.loading = true;

      this.$store
        .dispatch("indication/setCurrentDevicePlace", request)
        .then((response) => {
          this.$store.dispatch("indication/loadDevices");
        })
        .finally(() => {
          this.loading = false;
        }); 
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sub-item {
  opacity: 0.5;
}

.table-link {
  color: #7bc2eb;
  font-size: 0.9rem;
}

.table-additionally {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.table-icon {
  cursor: pointer;
}

.v-tooltip__content {
  border: 2px solid #d0cece;
  border-radius: 16px;
  background-color: #f2f2f2;
  color: $main-black;
  font-weight: 500;
  text-align: center;
  line-height: 1.2rem;
}

.select-prepend {
  white-space: nowrap;
}

.table-link {
  color: #7bc2eb;
  font-size: 0.9rem;
}

.table-additionally {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.table-icon {
  cursor: pointer;
}

.v-tooltip__content {
  border: 2px solid #d0cece;
  border-radius: 16px;
  background-color: #f2f2f2;
  color: $main-black;
  font-weight: 500;
  text-align: center;
  line-height: 1.2rem;
}

.current-place {
  &-container {
    position: relative;
    width: 100%;
    height: 100%;
  }

  $offsetTop: 12px;

  &-placeholder {
    top: $offsetTop;
    bottom: 0;
    color: #0068a3;
    position: absolute;
    // font-size: 12px;
    font-weight: 600;
    width: 100%;
    text-align: center;
    z-index: 4;
    text-decoration: underline;
    text-decoration-style: dotted;
    @media screen and (max-width: 600px) {
      position: static;
    }
  }

  &-value {
    top: 0;
    width: 100%;

    padding-top: $offsetTop;
    bottom: 0;
    /*background: red;*/
    z-index: 5;
    position: absolute;
  }

  &-disabled {
    opacity: 0.5;
  }
}

.save-btn {
  background-image: $green-gradient;
  color: white;
}
.pencil{
  color: $main-orange;
}
</style>
